/**
 * Created by Mark on 17/04/2017.
 */




import React  from 'react';

import LessonPlanService from '../services/songs-and-stories-services.js';
import LessonPlanStore from '../store/songa-and-stories-store.js';

import fuzzysearch from 'fuzzysearch';
import Translation from '../store/internationalization-store.js';
import {ListGroup , Col} from 'react-bootstrap';
import Popup from '../components/popup/information_popup.js';
import Select from  'react-select';
import LanguagenutPackage from '../classes/package.js';

class  FormattedMessage extends React.Component {
    constructor(props) {
        super();
        this.props = props;
    }

    render(){
       return  <span>{Translation.get(this.props.id , this.props.defaultMessage)}</span>
    }
}

export default class LessonPlansComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            plans:[],
            allPlans:[],
            language:{value: 'en' ,label: <FormattedMessage id={ '45' } defaultMessage={ 'language' }/> , data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            type: {value:"song" ,  label: <FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}
        }
    }


    componentDidMount() {
        LessonPlanService.getAll()
    }

    componentWillMount(){
        LessonPlanStore.on("CHANGE" , () => {
            this.setState({
                plans:LessonPlanStore.getAll(),
                allPlans:LessonPlanStore.getAll()
            });

            this.filterData(this.state.language , this.state.type)
        });
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.handelUserSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelUserSearch(searchTerm){

        var searchTerm = searchTerm.trim();

        if(searchTerm.length <= 3)
        {
            this.setState({plans:this.state.allPlans});
            return
        }


        var searchedRows = [];

        for(var idx = 0; idx < this.state.allPlans.length; idx++)
        {
            if(!this.state.allPlans[idx]) continue;


            if(fuzzysearch(String(searchTerm).toLowerCase() , String(this.state.allPlans[idx].name).toLowerCase()))
            {
                searchedRows.push(this.state.allPlans[idx]);
            }
        }

        this.setState({plans:searchedRows})
    }

    lessonPlanThumb(){

        var plans = [];

        for(var idx = 0 ; idx < this.state.plans.length; idx++)
        {
            let unitID = this.state.plans[idx].unit_uid;
            let code = this.state.plans[idx].language_code;
            let type = String(this.state.plans[idx].type).toLowerCase();

            let path = "img/school.png";

            if(Number(unitID) <= 6)
            {
                path = "img/farm.png";
            }

            if(Number(unitID) <= 12 && Number(unitID) > 6)
            {
                path = "img/school.png";
            }

            if(Number(unitID) <= 18 && Number(unitID) > 12)
            {
                path = "img/beach.png";
            }



            if(type === "story")
            {
                path = "img/Generic Book.png";
            }

            plans.push(<div className="col-sm-6 col-md-3">
                <a href={"#/"+type+"/"+unitID+"/"+code} className="thumbnail">
                    <div className="placeholder">

                        <img style={{maxHeight:150 , maxWidth:150 , width:"auto"}}src ={path}/>
                    </div>
                    <div className="caption">
                        <h4 className="titletextOverflow"><img className="avatar-img small" src={"img/flags/"+this.state.plans[idx].ietf+".png"} alt=""/>  <FormattedMessage id={ "142" } defaultMessage={ "No Results Found" }/> : {unitID}</h4>
                        <p style={{minHeight:"30px" , maxHeight:"30px"}}className="text-justify textOverflow" >{this.state.plans[idx].name}</p>
                        <div className="m-b-20">
                            <a  className="palette-Branding secondary bg btn btn-block waves-effect" role="button">
                                <span className="palette-White text">
                                    <FormattedMessage id={ "596" } defaultMessage={ "No Results Found" }/>
                                </span>
                            </a>
                        </div>
                    </div>
                </a>
            </div>)
        }

        return plans;
    }

    filterData(language , type){

        let media = [];
        for(var idx = 0 ; idx < this.state.allPlans.length; idx++)
        {
            if(language.value == this.state.allPlans[idx].ietf)
            {
                if(type.value == "both")
                {
                    media.push(this.state.allPlans[idx])
                }
                else
                {
                    if(type.value == "story" &&  String(this.state.allPlans[idx].type).toLowerCase() == "story")
                    {
                        media.push(this.state.allPlans[idx])
                    }

                    if(type.value == "song" &&  String(this.state.allPlans[idx].type).toLowerCase() == "song")
                    {
                        media.push(this.state.allPlans[idx])
                    }
                }

            }

        }

        this.setState({plans:media});

    };

    handelTypeSelection(type){

        this.filterData(this.state.language , type)
        console.log(type)
        this.setState({type:type});
    }

    handelLanguageSections(language){

        console.log(language)
        this.filterData(language , this.state.type)

        if(language.data.length == 1)
        {
            this.setState({language:language , type:language.data[0]});
            this.filterData(language , language.data[0])
        }
        else{
            this.setState({language:language});
            this.filterData(language , this.state.type)
        }

    }

    render(){
        var languages =[
            {value: 'af' ,label: <FormattedMessage id={ ""+'64' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'cn' ,label: <FormattedMessage id={ ""+'53' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'cy' ,label: <FormattedMessage id={ ""+'55' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'en' ,label: <FormattedMessage id={ ""+'45' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'en-us' ,label: <FormattedMessage id={ ""+'57' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'es' ,label: <FormattedMessage id={ ""+'47' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'es-MX' ,label: <FormattedMessage id={ ""+'58' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'fr' ,label: <FormattedMessage id={ ""+'46' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'gd' ,label: <FormattedMessage id={ ""+'56' } defaultMessage={ 'language' }/>, data:[{value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'ht' ,label: <FormattedMessage id={ ""+'65' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}]},
            {value: 'it' ,label: <FormattedMessage id={ ""+'49' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'ja' ,label: <FormattedMessage id={ ""+'51' } defaultMessage={ 'language' }/>, data:[{value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]},
            {value: 'ms' ,label: <FormattedMessage id={ ""+'67' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}]},
        ]

        if((new LanguagenutPackage()).isNewcomer()) {
            languages =[
                {value: 'en' ,label: <FormattedMessage id={ ""+'45' } defaultMessage={ 'language' }/>, data:[{value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>}, {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>}]}
            ]
        }






        const options = [
            {value:"story" , label:<FormattedMessage id={ "2015" } defaultMessage={ "Stories" }/>},
            {value:"song" ,  label:<FormattedMessage id={ "2014" } defaultMessage={ "Songs" }/>},
        ];

        let group = [];

        var plans = this.state.plans || [];
        for(var idx = 0 ; idx < plans.length; idx++)
        {
            group.push( <ListGroup.Item onClick={function(plan){this.setState({show:true , selected:plan})}.bind(this , plans[idx])}><img className="avatar-img small" src={"img/flags/"+this.state.plans[idx].ietf+".png"} alt=""/>&nbsp;&nbsp;&nbsp;<a className="hyperlink">{this.state.plans[idx].name}</a></ListGroup.Item>);
        }


        let selected  = this.state.selected || {};

        return (
           <div>

               <Popup

                   dialogClassName="modal-90w"
                   aria-labelledby="example-custom-modal-styling-title"
                   show={this.state.show} onHide={()=>{this.setState({show:false})}}>
                   <iframe frameborder="0" allowtransparency="true" height="750" style={{padding:0 , width:"100%" ,  border:"none"}} src = {"/admin/archive/?mode="+(this.state.type.value == 'song' ? 'Songs' : this.state.type.value)+"&unit="+(Number(selected.unit_uid) - 1)+"&language="+selected.language_code} />
               </Popup>
                      <div className="row">
                        <Col md={6}>
                            <div class="d-flex align-items-left">
                                <div class="p-2 report_title">
                                    {Translation.get(101 , 'Songs & Stories')}
                                </div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <Select
                                value={this.state.language}
                                onChange={this.handelLanguageSections.bind(this)}
                                options={languages}
                                />
                        </Col>
                        <Col md={3}>
                            <Select
                                value={this.state.type}
                                onChange={this.handelTypeSelection.bind(this)}
                                options={this.state.language.data}
                                noResultsText={<FormattedMessage id={ "2011"} defaultMessage={ "No Results Found" }/>} />
                        </Col>
                    </div>
                    <hr/>
                    <div className="row">
                        <Col md={12}>
                        <ListGroup>
                            {group}
                        </ListGroup>
                        </Col>
                    </div>
               </div>
        );
    }
}